import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/admin/Sidebar";
import Topbar from "../components/admin/Topbar";

function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="d-flex">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex-grow-1" style={{ marginLeft: 0 }}>
        <div className="d-lg-none" style={{ height: 0 }}></div>
        <div className="d-none d-lg-block" style={{ marginLeft: "260px" }}>
          <Topbar onMenuClick={() => setSidebarOpen(true)} />
          <main className="p-4">
            <Outlet />
          </main>
        </div>
        <div className="d-lg-none">
          <Topbar onMenuClick={() => setSidebarOpen(true)} />
          <main className="p-3">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;
